import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./RatesStatus.module.css";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { COUNTRY_CODE_MAP } from "../../../constants/constant";

const RatesStatus = ({ data }) => {
  const history = useHistory();

  const handleCountryClick = (countryCode) => {
    history.push('/interestBearing/ratesAllocation', { selectedCountry: countryCode });
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <div className={styles.titleSection}>
          <h3 className={styles.title}>Rates Status</h3>
          <CalendarTodayIcon className={styles.calendarIcon} />
        </div>
        {data && data.currentMonth && (
          <div className={styles.dateSection}>
            <span className={styles.date}>{data.currentMonth}</span>
          </div>
        )}
      </div>

      <div className={styles.listContainer}>
        {!data || !data.countries || data.countries.length === 0 ? (
          <div className={styles.emptyState}>No rate status data</div>
        ) : (
          data.countries.map((item, index) => (
            <div key={index} className={styles.listItem}>
              <span 
                className={styles.countryName}
                onClick={() => handleCountryClick(item.country)}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                {COUNTRY_CODE_MAP[item.country] || item.country}
              </span>
              {item.freezed ? (
                <LockIcon className={styles.lockIcon}   fontSize="small" />
              ) : (
                <LockOpenIcon className={styles.unlockIcon} fontSize="small" />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RatesStatus;
